// based on https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
export const postcode =
  /^([A-Z][A-HJ-Y]?[0-9][A-Z0-9]? ?[0-9][A-Z]{2}|GIR ?0A{2})$/;

// US ZIP code, with an optional ZIP+4 suffix
export const usZipCode = /^\d{5}(-\d{4})?$/;

// based on https://stackoverflow.com/questions/58767980/aws-cognito-password-regex-specific-to-aws-cognito
export const password =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

export const mobileNumberInText =
  /(\+(?:[0-9] ?){6,14}[0-9]|\b\d{5,6} ?\d{6}\b)/g;

export const iataCode = /\(([A-Z]{3})\)/;
